module.exports = __webpack_public_path__ + "img/pep-smart-outlet.1a4c53fb.png";